import { StyledLink } from '../share/styled';
export const StyledLinkText = StyledLink;